import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AboutMission from './pages/about-mission';
import MissionControlHub from './pages/mission-control-hub-homepage';
import CollaborationStation from './pages/collaboration-station';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<MissionControlHub />} />
        <Route path="/about-mission" element={<AboutMission />} />
        <Route path="/mission-control-hub-homepage" element={<MissionControlHub />} />
        <Route path="/collaboration-station" element={<CollaborationStation />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
